import { GOOGLE_XDP_SLUGS } from 'bundles/unified-description-page-common/constants/googleCerts';

// We have deprecated the duplicated google XDP certs.
// On prof cert and specialization pages we could serve valid product pages for these products.
// This util is used on s12n/prof cert pages to ensure we don't surface these products.
const isSlugDuplicatedGoogleCert = (slug: string) => {
  return GOOGLE_XDP_SLUGS.includes(slug);
};

export default isSlugDuplicatedGoogleCert;
